import { css } from "@emotion/react";

const tngStyles = css`
  &.tng {
    .header-text {
      color: #ffffff !important;
    }

    .page-wrapper {
      .second-part {
        span {
          color: #ffffff !important;
        }
        .header-style {
          color: #ffffff !important;
        }
      }

      .container {
        span {
          color: #ffffff !important;
        }

        .ticket-history-body {
          .header-style {
            color: #ffffff !important;
          }
        }
      }

      .prize-amount {
        span {
          color: #000000 !important;
        }
      }
    }

    .ticket-info-title,
    .ticket-info-container,
    .fontHeadStyle,
    .fontSubStyle,
    .tournament-history-btn,
    .stats-empty {
      color: #ffffff !important;
    }

    .back-arrow {
      fill: #ffffff !important;
      stroke: #ffffff !important;
    }

    .modal_container_2 {
      .contain-style {
        color: #ffffff !important;
      }
    }

    .name-sty {
      color: #000000 !important;
    }

    .section-header,
    .no-info,
    .not-active-button {
      color: #ffffff !important;
    }

    .activated-button {
      color: #c16eff !important;
    }

    .show-all-text {
      color: #ffffff !important;
    }

    .header-style,
    .arcade-headerSty2,
    .trending-game,
    .arcade-all-game,
    .played-count {
      color: #ffffff !important;
    }

    /* .icon {
      fill: #ffffff !important;
    } */

    .txt-style,
    .won-style,
    .label {
      color: #000000 !important;
    }

    .close {
      fill: #ffffff !important;
    }

    .drag-handle {
      &::after {
        color: #ffffff !important;
      }
    }

    .header-line {
      color: #ffffff !important;
    }

    .profile-pvp-stats {
      .title-md {
        color: #ffffff !important;
      }
    }

    .desktop-headerfont,
    .message-card {
      color: #ffffff !important;
    }

    .timer {
      .clock_icon {
        svg {
          fill: #ffffff !important;
        }
      }

      .timer-data {
        color: #ffffff !important;
      }
    }

    .header-container {
      .title {
        color: #ffffff !important;
      }
    }

    .play-btn-browse {
      background: #8b00f0 !important;
      span {
        color: #ffffff !important;
      }
    }

    .rank-btn {
      background: #8b00f0 !important;
    }

    .participant-counter-row {
      .count {
        color: #ffffff !important;
      }
    }
  }
`;

export default tngStyles;
